// extracted by mini-css-extract-plugin
export default {"mCard":"FD-z","image":"GD-z","imageNoBackground":"HD-z","imageHasCategory":"ID-z","fullWidth":"JD-z"};